<div class="wrapper mt-[40px]">
  <div class="attachment-block my-[40px]">
    <div class="label">
      Attachment:
    </div>
    <div (click)="openReport()" class="attachment-details flex justify-start items-start">
      <mat-icon
        [svgIcon]="'paperclip'"
        class="icon"
        />
      <span class="text-type-13 !leading-[22px] !text-[#1036D6]"> {{ reportTitle }} </span>
    </div>

  </div>
  <div class="workflow-list">
    @if (timelineSteps?.length > 0) {
      @for (step of timelineSteps; track step) {
        <div class="time-block">
          <div class="label-container flex flex-row gap-[12px] mb-[7px]">
            <div
              [ngClass]="{
              correct: step?.icon === 'correct',
              reject: step?.icon === 'reject'
            }"
              class="icon-container flex justify-center items-center"
              >
              <mat-icon
                [svgIcon]="step?.icon === 'reject' ? 'cross' : 'check'"
                class="workflow-icon"
                />
            </div>
            <div [ngClass]="step.status" class="timeline-label">
              {{ step?.state?.comment }}:
            </div>
          </div>
          <div class="details">
            <div class="user flex flex-row gap-[8px] mb-[16px]">
              <div class="user-avatar">
                {{ step?.actor?.first_name?.charAt(0) }}
              </div>
              <div class="user-details flex flex-col">
                <div class="user-name">
                  {{ step?.actorName }}
                </div>
                <div class="user-email">
                  {{ step?.actor?.email }}
                </div>
              </div>
            </div>
            @if (step?.input?.formValues?.comments) {
              <div class="comment mb-[8px]">
                Comment: {{ step?.input?.formValues?.comments }}
              </div>
            }
            <div
              [ngClass]="{ 'h-[55px]' : !step?.input?.formValues?.signature, 'mb-[8px] h-[12px]':step?.input?.formValues?.signature}"
              class="created-at-container">
              <div
                class="created-at flex flex-row justify-start items-center gap-[8px]"
                >
                <div>
                  {{ step?.created_at | date: "MMMM d, y" }}
                </div>
                <div>&#x25CF;</div>
                <div>
                  {{ step?.created_at | date: "hh:mm a" }}
                </div>
              </div>
            </div>
            @if (step?.input?.formValues?.signature) {
              <div class="signature-container h-[55px] mb-[8px]">
                <div class="signature">
                  {{ step?.input?.formValues?.signature }}
                </div>
              </div>
            }
          </div>
        </div>
      }
    } @else {
      <div
        class="no-data flex flex-col justify-center items-center gap-[20px]"
        >
        <div class="no-data-text text-center text-type-14">
          No logs available.
        </div>
      </div>
    }

  </div>
</div>

